import { gql } from '@apollo/client';

const PUBLISH_COURSE_MUTATION = gql`
    mutation publishCourse( $courseID: UUID! ) {
        result: publishCourse( courseID: $courseID ) {
            success
        }
    }
`;

export default PUBLISH_COURSE_MUTATION;
